<template>

    <div class="quick-search w-100">

        <user-search-dropdown placeholder="Quick Search Clients and Caregivers" @selectUser=" openProfile " :role=" role " excludeManagers="1"/>
    </div>
</template>

<script>

    import UsesRole from '../mixins/UsesRole';

    export default {

        name: 'QuickSearch',

        mixins: [ UsesRole ],

        data: () => ({

            options     : [],
            filter      : '',
            isSearching : false,
            loading     : false,
        }),

        methods: {

            openProfile( user ){

                const model = this.mapRoleToController( user.role_type );
                window.open( `/${this.controller}/${model}/${user.id}`, "_blank" );
            },
        }
    }

</script>